// src/components/Articles/ArticlesHero.jsx

import "./ArticlesHero.css";

export default function ArticlesHero() {
    return (
        <section className="articles-hero">

            <div className="articles-hero__background" />

            <div className="articles-hero__content">

                <span className="articles-hero__badge">
                    مجله سلامت
                </span>

                <h1>
                    دانستنی‌های سلامت
                    <br />
                    برای زندگی بهتر
                </h1>

                <p>
                    جدیدترین مطالب آموزشی درباره سلامت، تغذیه،
                    مکمل‌ها، پوست و مو و زیبایی
                </p>

            </div>

        </section>
    );
}